<template>
  <div id="UiHeader">
    <el-menu
      router
      :default-active="activeIndex"
      menu-trigger="click"
      background-color="#fff"
      text-color="#222"
      active-text-color="#ffd04b"
      mode="horizontal"
    >
      <!--      <el-switch v-model="alarmNotify" active-text="报警信息推送" @change="alarmNotifyChannge"></el-switch>-->
      <!--            <el-menu-item style="float: right;" @click="loginout">退出</el-menu-item>-->
      <el-submenu
        index=""
        style="float: right"
      >
        <template slot="title">欢迎，{{ username }}</template>
        <el-menu-item @click="changePassword">修改密码</el-menu-item>
        <el-menu-item @click="loginout">注销</el-menu-item>
      </el-submenu>
    </el-menu>
    <changePasswordDialog ref="changePasswordDialog"></changePasswordDialog>
  </div>
</template>

<script>
import changePasswordDialog from '../components/dialog/changePassword.vue'

export default {
  name: 'UiHeader',
  components: { Notification, changePasswordDialog },
  data () {
    return {
      alarmNotify: false,
      sseSource: null,
      activeIndex: this.$route.path,
      username: ''
    }
  },
  created () {
    if (this.$route.path.startsWith('/channelList')) {
      this.activeIndex = '/deviceList'
    }
  },
  mounted () {
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    // window.addEventListener('unload', e => this.unloadHandler(e))
    this.alarmNotify = this.getAlarmSwitchStatus() === 'true'
    this.sseControl()
    this.username = sessionStorage.getItem('username')
  },
  methods: {
    loginout () {
      this.$axios({
        method: 'get',
        url: '/api/user/logout'
      })
        .then(res => {
          this.exit()
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.exit()
            return
          }
          console.error('登出失败')
          console.error(error)
        })
    },
    exit () {
      this.$message.success('注销成功！')
      // 删除cookie，回到登录页面
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('username')
      sessionStorage.removeItem('userRole')
      sessionStorage.removeItem('userCompany')

      this.$router.push('/login')
      this.sseSource.close()
    },
    changePassword () {
      this.$refs.changePasswordDialog.openDialog()
    },
    openDoc () {
      console.log(process.env.BASE_API)
      window.open(!!process.env.BASE_API ? process.env.BASE_API + '/doc.html' : '/doc.html')
    },
    beforeunloadHandler () {
      this.sseSource.close()
    },
    alarmNotifyChannge () {
      this.setAlarmSwitchStatus()
      this.sseControl()
    },
    sseControl () {
      let that = this
      if (this.alarmNotify) {
        console.log('申请SSE推送API调用，浏览器ID: ' + this.$browserId)
        this.sseSource = new EventSource('/api/emit?browserId=' + this.$browserId)
        this.sseSource.addEventListener('message', function (evt) {
          that.$notify({
            title: '收到报警信息',
            dangerouslyUseHTMLString: true,
            message: evt.data,
            type: 'warning'
          })
          console.log('收到信息：' + evt.data)
        })
        this.sseSource.addEventListener(
          'open',
          function (e) {
            console.log('SSE连接打开.')
          },
          false
        )
        this.sseSource.addEventListener(
          'error',
          function (e) {
            if (e.target.readyState == EventSource.CLOSED) {
              console.log('SSE连接关闭')
            } else {
              console.log(e.target.readyState)
            }
          },
          false
        )
      } else {
        if (this.sseSource != null) {
          this.sseSource.removeEventListener('open', null)
          this.sseSource.removeEventListener('message', null)
          this.sseSource.removeEventListener('error', null)
          this.sseSource.close()
        }
      }
    },
    getAlarmSwitchStatus () {
      if (localStorage.getItem('alarmSwitchStatus') == null) {
        localStorage.setItem('alarmSwitchStatus', false)
      }
      return localStorage.getItem('alarmSwitchStatus')
    },
    setAlarmSwitchStatus () {
      localStorage.setItem('alarmSwitchStatus', this.alarmNotify)
    }
  },
  destroyed () {
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    if (this.sseSource != null) {
      this.sseSource.removeEventListener('open', null)
      this.sseSource.removeEventListener('message', null)
      this.sseSource.removeEventListener('error', null)
      this.sseSource.close()
    }
  }
}
</script>
<style>
#UiHeader .el-switch__label {
  color: white;
}

#UiHeader .el-switch__label.is-active {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/layout/UiHeader.vue